import React, {useState, useEffect, useRef} from 'react';
import {withTranslation} from 'react-i18next';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";
import Cookies from "js-cookie";
import {InputText} from "primereact/inputtext";
import moment from "moment";
import {addLocale, locale} from "primereact/api";
import {Badge} from "primereact/badge";
import {InputSwitch} from "primereact/inputswitch";

const RegistrationsListComponent = (props) => {
  const {t} = props;
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rows, setRows] = useState(10);
  const dt = useRef(null);
  const filterTextMatchModes = [
    {label: t('filter_like'), value: 'like'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
  ]
  const filterNumberMatchModes = [
    {label: t('filter_between_number'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const filterDateMatchModes = [
    {label: t('filter_between_date'), value: 'between'},
    {label: t('filter_equals'), value: '='},
    {label: t('filter_not_equals'), value: '!='},
    {label: t('filter_greather_than'), value: '>'},
    {label: t('filter_greather_than_or_equals'), value: '>='},
    {label: t('filter_less_than'), value: '<'},
    {label: t('filter_less_than_or_equals'), value: '<='},
  ]
  const [lazyParams, setLazyParams] = useState({
    first: Number(localStorage.getItem('registrations_first')) || 0,
    rows: Number(localStorage.getItem('registrations_rows')) || rows,
    page: Number(localStorage.getItem('registrations_page')) || 0,
    sortField: localStorage.getItem('registrations_sortField') || 'id',
    sortOrder: Number(localStorage.getItem('registrations_sortOrder')) || -1,
    filters: JSON.parse(localStorage.getItem('registrations_filters')) || null,
  });
  let loadLazyTimeout = null;
  const loadLazyData = () => {
    setLoading(true);
    if (loadLazyTimeout) {
      clearTimeout(loadLazyTimeout);
    }
    loadLazyTimeout = setTimeout(() => {
      let query = window.App.transformQueryParams(lazyParams)
      window.App.setState({rerenderRegistrationsList: false})
      axios({
        method: 'get',
        url: process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/user-registration" + query,
        params: {},
        headers: {
          'Authorization': 'Bearer ' + Cookies.get("userToken"),
          "Sys-name": Cookies.get("instanceId"),
          "Preferred-locale": Cookies.get("language")
        }
      })
        .then(response => {
          setTotalRecords(response.data.data.total_item_count);
          setRegistrations(response.data.data.items);
          setLoading(false);
        })
        .catch(error => {
          setLoading(false)
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPage = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onSort = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    setLazyParams(_lazyParams);
  }
  const onFilter = (event) => {
    let _lazyParams = {...lazyParams, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParams(_lazyParams);
  }
  const pager = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', registrationsSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions} onChange={(e) => setRows(e.target.value)}
                    />
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', registrationsSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button icon="pi pi-eye" className="p-button-sm  p-button-secondary"
                tooltip={t('show')}
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  window.App.setState({
                    sidebarRegistrationsShow: true,
                    propsRegistrations: {id: rowData.id}
                  })
                }}/>
        <Button icon="pi pi-cog" className="p-button-sm  p-button-secondary p-ml-2"
                tooltip="Beállítások"
                tooltipOptions={{position: 'left'}}
                onClick={() => {
                  window.App.setState({
                    sidebarRegistrationsForm: true,
                    propsRegistrations: {id: rowData.id}
                  })
                }}/>
      </React.Fragment>
    );
  }

  addLocale('default', {
    clear: t('filter_clear'),
    apply: t('filter_apply'),
  });
  locale('default');

  useEffect(() => {
    if (lazyParams.filters) {
      document.getElementById('search').value = '';
      localStorage.setItem('registrations_filters', JSON.stringify(lazyParams.filters))
      if (lazyParams.sortField) {
        localStorage.setItem('registrations_sortField', lazyParams.sortField)
      }
      if (lazyParams.sortOrder) {
        localStorage.setItem('registrations_sortOrder', lazyParams.sortOrder)
      }
      if (lazyParams.first >= 0) {
        localStorage.setItem('registrations_first', lazyParams.first)
      }
      if (lazyParams.page >= 0) {
        localStorage.setItem('registrations_page', lazyParams.page)
      }
      if (lazyParams.rows) {
        localStorage.setItem('registrations_rows', lazyParams.rows)
        setRows(lazyParams.rows)
      }
    }
    loadLazyData();
  }, [lazyParams, window.App.state.rerenderRegistrationsList])

  return (
    <>
      <div className={"p-grid"}>
        <div className={"p-col p-col-align-center"}>
          <h2 className={"p-m-0"}>{t('registrations_list')}</h2>
        </div>
        <div className={"p-col p-text-right p-col-align-center"}>
          {localStorage.getItem('registrations_filters') &&
            <a style={{color: "red"}} className={"p-button p-button-danger p-ml-2"}
               onClick={() => {
                 localStorage.removeItem('registrations_filters')
                 localStorage.removeItem('registrations_sortField')
                 localStorage.removeItem('registrations_sortOrder')
                 localStorage.removeItem('registrations_rows')
                 localStorage.removeItem('registrations_page')
                 localStorage.removeItem('registrations_first')
                 setLazyParams({
                   ...lazyParams,
                   filters: null
                 })
               }}
            >
              <i className={"pi pi-exclamation-triangle"}></i>&nbsp;{t('clear_filter')}
            </a>
          }
          <span className="p-input-icon-left p-ml-2">
              <i className="pi pi-search"/>
              <InputText id="search"
                         placeholder={t('search')}
                         onChange={(e) => {
                           clearTimeout(window.searchTimeout)
                           window.searchTimeout = setTimeout(function () {
                             localStorage.removeItem('registrations_filters')
                             localStorage.removeItem('registrations_sortField')
                             localStorage.removeItem('registrations_sortOrder')
                             localStorage.removeItem('registrations_rows')
                             localStorage.removeItem('registrations_page')
                             localStorage.removeItem('registrations_first')
                             setLazyParams({
                               ...lazyParams,
                               genericSearch: e.target.value,
                               filters: null
                             })
                           }, 1000)
                         }}
                         className={""}
              />
            </span>
        </div>
      </div>
      <DataTable
        ref={dt}
        size={"small"}
        emptyMessage={t('empty_message')}
        value={registrations} paginator first={lazyParams.first} totalRecords={totalRecords} onPage={onPage}
        onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
        onFilter={onFilter} filters={lazyParams.filters} loading={loading} lazy
        paginatorTemplate={pager} rows={rows} emptyMessage={t('empty_message')}
        autoLayout={true}
        filterDisplay="menu"
        responsiveLayout={window.App.state.responsiveLayout}
        breakpoint="1365px"
        stripedRows
        dataKey="id"
        selectionMode={"single"}
        onRowDoubleClick={(rowData) => {
          if (!rowData.data.deleted_at_snapshot) {
            window.App.setState({
              sidebarRegistrationsShow: true,
              propsRegistrations: {id: rowData.data.id}
            })
          }
        }}
      >
        
        <Column sortable header={t('status')} body={(rowData) => {
          if (rowData.subscriptions?.[rowData.subscriptions.length - 1].status === 'ACTIVE') {
            return (
              <Badge value={t('active')} severity="success" style={{width: '100%'}}></Badge>
            )
          }
          else if (rowData.subscriptions?.[rowData.subscriptions.length - 1].status === 'PAUSED') {
            return (
              <Badge value={t('paused')} severity="warning" style={{width: '100%'}}></Badge>
            )
          }
          else {
            return (
              <Badge value={t(rowData?.subscriptions?.[rowData.subscriptions.length - 1]?.status?.toLowerCase())} severity="secondary"
                     style={{width: '100%'}}></Badge>
            )
          }
        }}></Column>
        <Column sortable header={t('subscription_plan')} body={(rowData) => {
          return (
            <>
              {/*<i className={"pi pi-window-maximize"}*/}
              {/*   onClick={(e) => {*/}
              {/*     window.App.setState({*/}
              {/*       sidebarSubscriptionplanShow: true,*/}
              {/*       propsSubscriptionplan: {id: rowData?.subscriptions?.[0]?.subscription_plan?.id}*/}
              {/*     })*/}
              {/*   }}*/}
              {/*></i>*/}
              {/*&nbsp;*/}
              {rowData?.subscriptions?.[rowData.subscriptions.length - 1]?.subscription_plan?.name}
            </>
          )
        }}></Column>
        <Column field="email" sortable header={t('email')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}></Column>
        <Column field="system_name" sortable header={t('instance_name')}
                filter
                filterMatchMode="like"
                filterMatchModeOptions={filterTextMatchModes}></Column>
        <Column field="enabled" sortable header={t('active')} body={(rowData) => {
          return (
            <>
              <InputSwitch
                className={"p-mt-1"}
                name={"automatic_daily_close_case_of_out_of_order"}
                checked={rowData.enabled}
                disabled={rowData.email === localStorage.getItem('userEmail')}
                onChange={(e) => {
                  axios.patch(process.env.REACT_APP_API_PROTOCOL + process.env.REACT_APP_API_HOST + "system-admin/user-registration/" + rowData.id,
                    {
                      enabled: e.value
                    },
                    {
                      params: {},
                      headers: {
                        'Authorization': 'Bearer ' + Cookies.get("userToken"),
                        "Sys-name": Cookies.get("instanceId"),
                        "Preferred-locale": Cookies.get("language")
                      }
                    })
                    .then(response => {
                      loadLazyData()
                    })
                    .catch(error => {
                      window.App.toastShow('error', t('error'), error.response.data.message, '', error.response)
                    })
                }}/>
            </>
          )
        }}></Column>
        <Column field="created_at_snapshot" sortable header={t('created_at')}
                filter
                filterField={"created_at"}
                sortField={"created_at"}
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.created_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.created_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column field="updated_at_snapshot" sortable header={t('updated_at')}
                filterField={"updated_at"}
                sortField={"updated_at"}
                filter
                filterMatchMode="between"
                filterMatchModeOptions={filterDateMatchModes}
                body={(rowData) => {
                  if (rowData.updated_at_snapshot !== null) {
                    return (
                      <span>{moment.utc(rowData.updated_at_snapshot).local().format(t('YYYY-MM-DD HH:mm:ss'))}</span>
                    )
                  }
                }}></Column>
        <Column body={actionBodyTemplate} className={"p-py-0 p-text-nowrap p-text-right"}></Column>
      </DataTable>
    </>
  )
}
export default withTranslation('common')(RegistrationsListComponent);
